import React, { useEffect, useState } from 'react';
import { TabsBar } from '../../../shared/components/Tab/Tabs';
import { Card, VideoContainer } from './styles';
import { createClipTab, transcriptTab } from './tabs';
import { useVideoPlayer } from '../../../video/hooks';
import { coreService } from '../../../../services/core/core-service';
import { useToast } from '../../../../hooks/useToast';
import { extractError } from '../../../../utils/api';
import { Video } from '../Video/Video';
import { useRecapManagement } from '../../../recapv2/recap-management/hook';
import { useClipEventStore } from '../../store/clip.store';

export const VideoAndTranscript: React.FC = () => {
  const { permissions, id, playback, cropping } = useRecapManagement();
  const recapId = id;
  const { setIsEditable, setCropCallback, setCropping, setContainerRef } = useVideoPlayer();
  const { success, error } = useToast();

  const [activeTab, setActiveTab] = useState('transcript');

  const { subscribe } = useClipEventStore();

  useEffect(() => {
    const unsubscribe = subscribe('changeTab', (tab: string) => {
      setActiveTab(tab);
    });

    return () => {
      unsubscribe();
    };
  }, []);

  useEffect(() => {
    // Assuming that the video will only be editable if the user has the permission to manage share links.
    setIsEditable(permissions.canManageShareLinks);
  }, [permissions.canManageShareLinks]);

  useEffect(() => {
    if (playback) {
      setCropping({ start: cropping.start, end: cropping.end });
    }
  }, [playback, cropping]);

  useEffect(() => {
    setCropCallback(args => {
      return coreService
        .cropPlaybackCropping(recapId, args)
        .then(() => {
          success('Video saved successfully');
        })
        .catch(apiError => {
          const errorMessage = extractError(apiError);
          error(errorMessage);
        });
    });
  }, [recapId]);

  return (
    <Card>
      <VideoContainer ref={setContainerRef}>
        <Video />
      </VideoContainer>
      <TabsBar
        defaultKey={activeTab}
        key={activeTab}
        items={[transcriptTab, createClipTab]}
        onTabChange={setActiveTab}
      />
    </Card>
  );
};
